<!-- 注册信息填写 -->
<template>
  <div class="message">
    <!-- 导航栏 -->
    <van-nav-bar :title="type==0?'基本资料':'注册企业'" fixed placeholder z-index="10" @click-left="goBack">
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 企业信息 -->
    <div class="msg-compony msg-box" v-if="type==0">
      <p class="msg-logo">面试官信息</p>
      <!-- 面试官信息 -->
      <div class="box">
        <div class="reg-item">
          <p class="name">名称</p>
          <input type="text" v-model="contact" placeholder="请输入您的称呼" />
        </div>

        <div class="reg-item">
          <p class="name">职位</p>
          <input type="text" v-model="position" placeholder="请输入职位信息" />
        </div>

        <div class="reg-item">
          <p class="name">手机号</p>
          <input type="text" v-model="telphone" placeholder="请输入手机号" />
        </div>
      </div>
    </div>
    <!-- 企业logo或门店照片 -->
    <div class="msg-box">
      <div class="msg-logo">企业logo或门店照片</div>
      <van-uploader :after-read="afterRead" v-model="logoImg" :show-upload="upload" @delete="colse">
        <div class="add-img">
          <img src="@/assets/img/home/add.png" class="add" />
          <p>添加图片</p>
        </div>
      </van-uploader>
    </div>
    <!-- 企业信息 -->
    <div class="msg-compony msg-box">
      <p class="msg-logo">企业信息</p>
      <div class="box">
        <!-- 名称 -->
        <div class="reg-item">
          <p class="name">名称</p>
          <input type="text" v-model="name" placeholder="请输入企业名称" />
        </div>
        <!-- 性质 -->
        <div class="reg-item flex" @click="show=true">
          <div class="felx-left">
            <p class="name">性质</p>
            <input type="text" v-model="nature" placeholder="请选择企业性质" disabled />
          </div>
          <img :src="into" class="back" />
        </div>
        <van-popup v-model="show" round position="bottom">
          <van-picker
            show-toolbar
            :columns="natureList"
            @confirm="selectnature"
            @cancel="show=false"
            value-key="name"
          />
        </van-popup>
        <!-- 行业 -->
        <div class="reg-item flex" @click="showPicker=true">
          <div class="felx-left">
            <p class="name">行业</p>
            <input type="text" v-model="Industry" placeholder="请选择行业" disabled />
          </div>
          <img :src="into" class="back" />
        </div>
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="IndustryList"
            @confirm="selectIndustry"
            @cancel="showPicker=false"
            value-key="name"
          />
        </van-popup>
        <!-- 名称 -->
        <div class="reg-item flex" @click="navGo">
          <div class="felx-left">
            <p class="name">所属地区</p>
            <input type="text" :value="companyAddress[0]" placeholder="请选择所属地区" disabled />
          </div>
          <img :src="into" class="back" />
        </div>
        <!-- 地址填写 -->
        <div class="reg-item">
          <p class="name">详细地址</p>
          <van-field
            v-model="address"
            rows="3"
            autosize
            type="textarea"
            maxlength="100"
            placeholder="请填写具体地址"
            show-word-limit
          />
          <!-- <input type v-model="address" placeholder="请填写具体地址" /> -->
        </div>
      </div>
    </div>

    <!-- 营业执照 -->
    <div class="msg-box">
      <div class="msg-logo">营业执照(选填)</div>
      <van-uploader
        :after-read="afterReaded"
        v-model="logoImgs"
        :show-upload="uploaded"
        @delete="colsed"
      >
        <div class="add-img">
          <img src="@/assets/img/home/add.png" class="add" />
          <p>添加图片</p>
        </div>
      </van-uploader>
    </div>
    <!-- 企业介绍 -->
    <div class="msg-box msg-left">
      <div class="msg-logo">企业介绍</div>
      <van-field
        v-model="introduction"
        rows="6"
        autosize
        type="textarea"
        maxlength="400"
        placeholder="请简单介绍下企业~"
        show-word-limit
      />
      <van-uploader
        :after-read="afterReads"
        v-model="compony"
        :show-upload="uploads"
        @delete="colseds"
      >
        <div class="add-img">
          <img src="@/assets/img/home/add.png" class="add" />
          <p>添加图片</p>
        </div>
      </van-uploader>
      <div class="list-item">
        <span
          :class="{'list-welfare ':true,'check':item.selected}"
          @click="bindTag(index,item.category_id)"
          v-for="(item, index) in tag"
          :key="index"
        >{{item.name}}</span>
      </div>
    </div>
    <div class="login-lianxi">
      <a href="tel:85711525">就业创业科联系电话：85711525</a>
    </div>
    <!-- 提交注册 -->
    <div class="placeholder">
      <div class="request-btn" @click="btnSumbit">
        <button class="btns">{{type==0?'保存':token==2?'保存':'提交注册'}}</button>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <van-dialog v-model="shows" title="提交成功，正在审核" @confirm="confirm">
      <p class="tips">预计1个工作日内完成审核，请耐心等待审核结果~</p>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import {
  upLoad,
  getKindArray,
  companyRegister,
  getCompanyDetail,
  editCompanyInfo,
  companyUpdateRegisterInfo
} from "@/api/apiData";
import { regTelphone } from "@/until/reg";
import { mapState, mapMutations } from "vuex";
export default {
  name: "indexs",
  components: {},
  data() {
    return {
      area: "", //所属地区
      type: "", //0 面试官资料  undefined注册
      into: require("@/assets/img/position/into.png"),
      logoImg: [],
      logoImgs: [],
      uploaded: true, //营业执照
      upload: true, //logo区域
      uploads: true, //企业图片
      name: "", //企业名称
      nature: "", //性质
      natureId: "", //性质id
      Industry: "", //行业
      IndustryId: "", //行业id
      tag: [], //福利标签
      natureList: [], //企业性质
      IndustryList: [], //行业
      show: false,
      showPicker: false,
      address: "", //地址
      introduction: "", //企业介绍
      checke: false,
      compony: [], //企业照片,
      shows: false,
      logo: ["", "", []],
      tagId: [], //福利id
      contact: "",
      position: "",
      telphone: ""
    };
  },
  computed: {
    ...mapState(["params", "companyAddress", "token"])
  },
  methods: {
    ...mapMutations(["selectAddress", "companyRegister", "keepAliveRouter"]),
    navGo() {
      const that = this;
      that.$router.push({
        name: "Address",
        query: {
          entrance: "2"
        }
      });
    },
    //   返回
    goBack() {
      this.$router.back();
    },
    // 获取分类
    getKindsAll() {
      const that = this;
      var params = that.params;
      // 企业性质
      getKindArray({ key: "company_type" }).then(res => {
        if (res.code == 1) {
          that.natureList = res.data;
          // 行业性质
          getKindArray({ key: "trade" }).then(res => {
            if (res.code == 1) {
              that.IndustryList = res.data;
              // 福利标签
              getKindArray({ key: "jobtag" }).then(res => {
                if (res.code == 1) {
                  var list = res.data;
                  list.forEach(item => {
                    item.selected = false;
                  });
                  that.tag = res.data;
                  if (that.type == 0) {
                    that.getInformation();
                  } else {
                    if (that.token == 2) {
                      var params = that.params[5];
                      that.upload = false;
                      that.logoImg[0] = { url: params.logo };
                      that.logo[0] = params.logo;
                      that.name = params.name;
                      // 企业性质
                      that.natureList.forEach(item => {
                        if (item.category_id == params.nature) {
                          that.nature = item.name;
                          that.natureId = params.nature;
                        }
                      });
                      // 行业
                      that.IndustryList.forEach(item => {
                        if (item.category_id == params.trade) {
                          that.Industry = item.name;
                          that.IndustryId = params.trade;
                        }
                      });
                      // 地区
                      that.selectAddress([
                        params.district_name,
                        params.district
                      ]);
                      // 详细地址
                      that.address = params.address;
                      // 营业执照

                      if (params.business_license != "") {
                        that.uploaded = false;
                        that.logoImgs[0] = { url: params.business_license };
                      }

                      that.logo[1] = params.business_license;
                      // 企业介绍
                      that.introduction = params.content;
                      // 企业图片
                      let arr = params.images.split(",");
                      let arrs = [];
                      arr.forEach(item => {
                        let infos = {};
                        infos.url = item;
                        arrs.push(infos);
                      });
                      that.compony = arrs;
                      that.logo[2] = arr;
                      // 福利标签
                      let tagId = params.tag;
                      if (params.tag != "") {
                        that.tagId = tagId;
                        that.tag.forEach(item => {
                          tagId.forEach(it => {
                            if (item.category_id == it) {
                              item.selected = true;
                            }
                          });
                        });
                      }
                    }
                  }
                } else {
                  Toast(res.msg);
                  setTimeout(() => {
                    that.$router.back();
                  }, 2000);
                }
              });
            } else {
              Toast(res.msg);
              setTimeout(() => {
                that.$router.back();
              }, 2000);
            }
          });
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    },
    // logo上传成功后的回调函数
    afterRead(file) {
      this.upload = false;
      upLoad({ file: file.content }).then(res => {
        if (res.code == 1) {
          this.logo[0] = res.data.path; //logo
        } else {
          Toast(res.msg);
        }
      });
    },
    // 营业执照上传
    afterReaded(file) {
      this.uploaded = false;
      upLoad({ file: file.content }).then(res => {
        if (res.code == 1) {
          this.logo[1] = res.data.path; //logo
        } else {
          Toast(res.msg);
        }
      });
    },
    // 企业照片上传
    afterReads(val) {
      upLoad({ file: val.content }).then(res => {
        this.uploaded = false;
        if (res.code == 1) {
          this.logo[2].push(res.data.path); //企业照片
        } else {
          Toast(res.msg);
        }
      });
    },
    // 删除logo
    colse(file) {
      const that = this;
      that.logo[0] = "";
      this.upload = true;
    },
    // 删除营业执照
    colsed(file) {
      const that = this;
      that.logo[1] = "";
      this.uploaded = true;
    },
    // 删除门店图片
    colseds(file, val) {
      const that = this;
      let index = val.index;
      let { logo } = that;
      logo[2].splice(index, 1);
      that.logo = logo;
    },
    // 选择企业性质
    selectnature(val) {
      //(val);
      var that = this;
      that.nature = val.name;
      that.natureId = val.category_id;
      that.show = false;
    },
    // 选择行业分类
    selectIndustry(val) {
      //(val);
      var that = this;
      that.Industry = val.name;
      that.IndustryId = val.category_id;
      that.showPicker = false;
    },
    // 选择福利
    bindTag(val, id) {
      var that = this;
      that.tag[val].selected = !that.tag[val].selected;
      if (that.tag[val].selected) {
        that.tagId = that.tagId.concat(id);
      } else {
        that.tagId.forEach((item, index) => {
          if (item == id) {
            that.tagId.splice(index, 1);
          }
        });
      }
      that.idx = val;
    },
    //提交注册
    btnSumbit() {
      var that = this;
      let {
        logo,
        name,
        nature,
        Industry,
        address,
        introduction,
        tagId,
        params,
        IndustryId,
        natureId,
        companyAddress,
        type,
        token,
        contact,
        position,
        telphone
      } = that;
      if (type == 0) {
        if (contact.replace(/[, ]/g, "").length == 0) {
          Toast.fail({
            message: "请填写名称",
            forbidClick: true
          });
          return;
        }
        if (position.replace(/[, ]/g, "").length == 0) {
          Toast.fail({
            message: "请填写职位",
            forbidClick: true
          });
          return;
        }
        if (!regTelphone(telphone)) {
          Toast.fail({
            message: "请填写正确的手机号码",
            forbidClick: true
          });
          return;
        }
      }
      if (logo[0] == "null") {
        Toast.fail({
          message: "请上传企业logo或者门店照片",
          forbidClick: true
        });
        return;
      }
      if (name.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请输入企业名称",
          forbidClick: true
        });
        return;
      }
      if (nature.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请选择企业性质",
          forbidClick: true
        });
        return;
      }
      if (Industry.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请选择行业",
          forbidClick: true
        });
        return;
      }
      if (companyAddress[0] === "") {
        Toast.fail({
          message: "请选择所属地区",
          forbidClick: true
        });
        return;
      }
      if (address.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请填写具体地址",
          forbidClick: true
        });
        return;
      }
      if (introduction.replace(/[, ]/g, "").length == 0) {
        Toast.fail({
          message: "请简单介绍下企业",
          forbidClick: true
        });
        return;
      }
      if (logo[2].length == 0) {
        Toast.fail({
          message: "请添加点企业照片",
          forbidClick: true
        });
        return;
      }
      if (tagId.length == 0) {
        Toast.fail({
          message: "请添加福利",
          forbidClick: true
        });
        return;
      }
      if (type == 0) {
        let obj = {
          token: that.token,
          logo: logo[0],
          images: logo[2].toString(),
          name: name,
          business_license: logo[1],
          nature: natureId,
          trade: IndustryId,
          district: companyAddress[1],
          contact: contact,
          contact_position: position,
          telphone: telphone,
          address: address,
          content: introduction,
          tag: tagId.toString()
        };
        editCompanyInfo(obj).then(res => {
          // //(res);
          if (res.code == 1) {
            Toast.success({
              message: "修改成功",
              forbidClick: true
            });
            setTimeout(() => {
              that.$router.back();
            }, 2000);
          } else {
            Toast.fail(res.msg);
          }
        });
      } else {
        let obj = {
          username: params[3],
          password: params[4],
          logo: logo[0],
          business_license: logo[1],
          images: logo[2].toString(),
          name: name,
          nature: natureId,
          trade: IndustryId,
          district: companyAddress[1],
          contact: params[0],
          contact_position: params[1],
          telphone: params[2],
          address: address,
          content: introduction,
          tag: tagId.toString()
        };
        if (that.token == 2) {
          // 信息修改
          companyUpdateRegisterInfo(obj).then(res => {
            //(res);
            if (res.code == 1) {
              Dialog.alert({
                title: "提示",
                message: res.msg
              }).then(() => {
                that.$router.replace("/login/account");
              });
            }
          });
        } else {
          // 注册
          companyRegister(obj).then(res => {
            //(res);
            if (res.code == 1) {
              that.shows = true;
            } else {
              Toast.fail(res.msg);
            }
          });
        }
      }
    },
    confirm() {
      this.companyRegister({});
      this.keepAliveRouter("1");
      this.$router.replace("/login/account");
    },
    // 获取企业详情
    getInformation() {
      var that = this;
      let tag = that.tag;
      getCompanyDetail({ token: this.token }).then(res => {
        //(res);
        if (res.code == 1) {
          that.contact = res.data.contact;
          that.position = res.data.contact_position;
          that.telphone = res.data.telphone;
          that.logoImg = that.logoImg.concat({ url: res.data.logo });
          that.upload = res.data.logo == "" ? true : false;
          that.logo[0] = res.data.logo;
          that.name = res.data.name;
          that.nature = res.data.nature_name;
          that.natureId = res.data.nature;
          that.Industry = res.data.trade_name;
          that.IndustryId = res.data.trade;
          that.selectAddress([res.data.district_name, res.data.district, "2"]);
          that.address = res.data.address;
          that.logoImgs =
            res.data.business_license == ""
              ? []
              : that.logoImgs.concat({ url: res.data.business_license });
          that.logo[1] = res.data.business_license;
          that.uploaded = res.data.business_license == "" ? true : false;
          that.introduction = res.data.content;
          that.logo[2] = res.data.images;
          if (res.data.images.length > 0) {
            var arrImg = [];
            res.data.images.forEach(item => {
              var info = {};
              info.url = item;
              arrImg.push(info);
            });
          }

          that.compony = arrImg;
          let tagId = res.data.tag;
          if (res.data.tag != "") {
            that.tagId = tagId;
            tag.forEach(item => {
              tagId.forEach(it => {
                if (item.category_id == it) {
                  item.selected = true;
                }
              });
            });
          }
        }
      });
    }
  },
  created() {
    let that = this;
    that.type = that.$route.query.type;
    that.$nextTick(() => {
      that.getKindsAll();
    });
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
/deep/.van-uploader__preview {
  margin: 0.13rem;
  margin-right: 0.48rem;
}

/deep/.van-uploader__preview:nth-child(3n-2) {
  margin-left: 0.32rem;
}
/deep/.van-cell__value--alone {
  border: 0.01rem solid #e6e6e6;
  padding: 0.2rem;
}
/deep/.van-cell:not(:last-child)::after {
  border: 0;
}
/deep/.van-dialog {
  padding-bottom: 0.2rem;
}
/deep/.van-button__text {
  width: 90% !important;
  border-radius: 0.2rem !important;
  padding: 0.2rem 0 !important;
  color: #fff !important;
  background: #ff4343 !important;
}

.message {
  background: #f7f7f7;
  padding: 0 0.32rem 0.32rem;
}
.placeholder::before {
  content: "";
  display: block;
  width: 100%;
  height: 1rem;
}
.login-lianxi {
  font-size: 0.3rem;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 0.5rem 5%;
}
.tips {
  font-size: 0.3rem;
  text-align: center;
  padding: 0.4rem;
  font-weight: 400;
  line-height: 0.42rem;
  color: rgba(102, 102, 102, 1);
}
// 信息上传
.msg-box {
  padding-bottom: 0.2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  margin: 0.2rem 0;
  .list-item {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0.3rem 0.32rem;
    .list-welfare {
      padding: 0.06rem 0.1rem;
      margin: 0.1rem 0;
      background: rgba(248, 248, 248, 1);
      border-radius: 0.04rem;
      color: rgba(153, 153, 153, 1);
      font-size: 0.28rem;
      margin-right: 0.16rem;
      line-height: 0.33rem;
      border: 0.01rem solid rgba(248, 248, 248, 1);
    }
    .check {
      color: #ff4343;
      background: rgba(255, 67, 67, 0.3);
      border: 0.01rem solid #ff3366;
    }
  }
  .msg-logo {
    width: 100%;
    text-align: center;
    font-size: 0.28rem;
    font-weight: bold;
    line-height: 0.4rem;
    color: rgba(51, 51, 51, 1);
    padding: 0.2rem 0;
    border-bottom: 0.01rem solid rgba(178, 178, 178, 0.3);
  }
  .add-img {
    margin: 0.2rem 0 0 0.32rem;
    width: 1.48rem;
    height: 1.48rem;
    border-radius: 0.12rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 0.02rem dashed #e6e6e6;
    .add {
      width: 0.48rem;
      height: 0.48rem;
    }
    p {
      font-size: 0.22rem;

      font-weight: 400;
      line-height: 0.3rem;
      color: rgba(153, 153, 153, 1);
    }
  }
}
.msg-left {
  align-items: flex-start;
}
.msg-box:nth-child(5) {
  margin-bottom: 1.5rem;
}
// 企业信息
.msg-compony {
  background: #fff;
  .box {
    width: 100%;
    padding: 0 0.32rem;
    .reg-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 0.3rem 0 0.2rem;
      border-bottom: 0.01rem solid #e5e5e5;
      .name {
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.4rem;
        color: rgba(128, 128, 128, 1);
        width: 100%;
      }
      input {
        width: 100%;
        font-size: 0.3rem;
        line-height: 0.4rem;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        margin-top: 0.1rem;
        background: #fff;
      }

      /deep/.van-cell {
        padding: 0.1rem 0;
      }
      .left {
        width: 55%;
      }
      /deep/.van-field__control::-webkit-input-placeholder {
        font-size: 0.3rem;
        font-weight: 400;
        line-height: 0.5rem;
        color: rgba(229, 229, 229, 1);
      }
      input::-webkit-input-placeholder {
        font-size: 0.3rem;
        font-weight: 400;
        line-height: 0.5rem;
        color: rgba(229, 229, 229, 1);
      }
      .code {
        width: 2.48rem;
        height: 1.28rem;
        align-self: flex-end;
      }
      .btn-code {
        background: #e5e5e5;
        border: 0.01rem solid #cccccc;
        opacity: 1;
        border-radius: 0.08rem;
        font-size: 0.2rem;
        padding: 0.22rem 0.3rem;
        align-self: flex-end;
        margin-bottom: 0.2rem;
      }
    }
    .flex {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
    }
    .felx-left {
      display: flex;
      flex-direction: column;
    }
    .reg-item:last-child {
      border: 0;
    }
  }
}
</style>